<template>
    <div v-if="selectedDeal">
        <MiniDealModal :dealDetails="selectedDeal" :showDealPrice="showDealPrice" />
    </div>  
    <div>
        <div v-if="isLoading" class="deals-wrapper">
            <LoadMoreDeals v-if="!isGiftList" />            
        </div>
        <div v-if="isClean && listOfDeals">
            <input placeholder="Search..." v-model="filterText" @input="onFilterChange()" />
        </div>
        <div id="deals-wrapper" v-if="!isGiftList && deals && deals.length > 0">
            
            <div v-for="(deal, index) in deals" v-bind:item="deal" v-bind:index="index" v-bind:key="deal.DealID" class="deals-wrapper-item">
                <div v-if="deal.DealID > 1000000000" ref="adlist">

                    <div v-if="deal.adType === 'GOOGLE'" class="ad-container">
                        <ins class="adsbygoogle"
                             style="display:block"
                             data-ad-format="fluid"
                             data-ad-layout-key="-8b-22+5x-8o-ai"   
                             data-ad-client="ca-pub-7343448629459478"
                             data-ad-slot="8520665225">
                        </ins>
                    </div>
                    <div v-else-if="deal.adType === 'MEDIA.NET'">
                        <div id="471381230"></div>
                    </div>
                    <div v-else-if="deal.adType === 'JCN'">
                        <div class="jcn-ad-container" v-html="deal.adContent">
                        </div>
                    </div>
                    <div v-else class="join-us-deal-container">
                        <a :href="settings.socialLinks.whatsapp" target="_blank">
                            <img :src="'/Assets/' + settings.siteName + '/img/deal-join-whatsapp.jpg'" />
                        </a>
                    </div>
                </div>
                <DealBox v-else :deal="deal" :index="index" class="deals-wrapper-dealbox" :directLinks="directLinks" :showPrice="showPrice" />
            </div>
        </div>
        <div id="gift-list-wrapper" v-if="isGiftList && deals && deals.length > 0">
            <div v-for="(deal, index) in deals"
                 v-bind:item="deal"
                 v-bind:index="index"
                 v-bind:key="deal.DealID"
                 class="gift-list-wrapper-item">
                <DealBox :deal="deal" :index="index" class="deals-wrapper-dealbox" :directLinks="directLinks" :showPrice="showPrice" />
            </div>
        </div>
        <div class="load-more-container" v-if="showMoreDealsButton">
            <button v-if="isLoadingMore === true">
                <span class="icon"><img :src="`/Assets/img/spin.svg`" /></span>
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount, computed } from 'vue'
import LoadMoreDeals from '@/components/LoadMoreDeals.vue'
import DealBox from '@/components/DealBox.vue'
import api from '@/api'
import settings from '@/settings'
import ga from '@/helpers/ga'
import clicky from '@/helpers/clicky'
import util from '@/helpers/util'
import { DealDetails } from '@/classes/DealDetails'
import MiniDealModal from './MiniDealModal.vue'
import { globalStore } from '@/stores/globalStore'

declare global {
    interface Window {
        adsbygoogle: any[]
        _mNHandle: {
            queue: Function[]
        }
        _mNDetails: {
            loadTag: (id: string, size: string, targetId: string) => void
        }
    }
}

export default defineComponent({
    name: 'home',
    components: {
        DealBox,
        LoadMoreDeals,
        MiniDealModal
    },
    props: {
        excludeDeal: {
            type: Number,
            default: null
        },
        listOfDeals: { 
            type: Array as () => DealDetails[] | null,
            default: null
        },
        date: {
            type: String,
            default: ''
        },
        showJoinUs: {
            type: Boolean,
            default: false
        },
        directLinks: {
            type: Boolean,
            default: false
        },
        showPrice: {
            type: Boolean,
            default: true
        }
    },
    setup(props) {
        const store = globalStore()
        const isLoading = ref(true)
        const isLoadingMore = ref(false)
        const deals = ref<DealDetails[]>([])
        const dealsPerPage = ref(settings.siteName === 'mommydeals' ? 15 : 16)
        const pageNumber = ref(1)
        const showMoreDealsButton = ref(false)
        const autoLoadMoreEnabled = ref(false)
        const oneSignalInitiated = ref(false)
        const isGiftList = ref(false)
        const isClean = ref(false)
        const filterText = ref<string | null>(null)
        const filterCounter = ref(0)

        const finalExcludeDeal = computed(() => props.excludeDeal || 0)

        const selectedDeal = computed(() => store.selectedDeal)
        const showDealPrice = computed(() => store.showDealPrice)

        const onFilterChange = () => {
            filterCounter.value++
            const currentCounter = filterCounter.value
            setTimeout(() => {
                if (currentCounter === filterCounter.value) {
                    deals.value = props.listOfDeals.filter(d => d.Title?.toLowerCase().includes(filterText.value?.toLowerCase() || ''))
                }
            }, 500)
        }

        const loadGoogleAds = () => {
            setTimeout(() => {
                (window.adsbygoogle = window.adsbygoogle || []).push({})
            }, 100)
        }

        const postLoadData = (response: { data: DealDetails[] }) => {
            if (response.data) {
                let newDeals = response.data

                //partial of deal details
                let adDeal: DealDetails = new DealDetails({ 
                    DealID: 1000000000 + pageNumber.value,
                    Title: 'Advertisement'
                })

                if (newDeals.length < dealsPerPage.value) showMoreDealsButton.value = false

                if (settings.siteName === 'mommydeals' || settings.siteName === '5tcdeals')
                    newDeals.splice(3, 0, adDeal)

                deals.value.push(...newDeals)
                pageNumber.value = pageNumber.value + 1

                setTimeout(() => {
                    autoLoadMoreEnabled.value = true
                }, 500)

                if (settings.siteName === 'mommydeals') {
                    let randomNumber = Math.floor(Math.random() * 6)
                    let zid = 108
                    let pid = settings.jcn_pid
                    let jcn_ads_on = settings.jcn_ads_on
                    let medianet_on = settings.medianet_on && randomNumber == 0
                    let isJCNAd = true

                    if (medianet_on) {
                        try {
                            adDeal.adType = 'MEDIA.NET'
                            setTimeout(() => {
                                window._mNHandle.queue.push(function () {
                                    window._mNDetails.loadTag("471381230", "300x250", "471381230")
                                })
                            }, 100)
                        }
                        catch (error) {
                            console.log('Media.net ERROR', error)
                        }
                    }
                    else if (jcn_ads_on) {
                        api.getJCNAd(zid, pid).then((response) => {
                            console.log('JCN response', response)
                            isJCNAd = response && response.data && response.data.includes('<body')

                            if (isJCNAd) {
                                adDeal.adContent = response.data
                                adDeal.adType = 'JCN'
                            }
                            else {
                                adDeal.adType = 'GOOGLE'
                                loadGoogleAds()
                            }

                            console.log('AD TYPE', adDeal.adType)
                        })
                    }
                    else {
                        adDeal.adType = 'GOOGLE'
                        loadGoogleAds()
                        console.log('AD TYPE', adDeal.adType)
                    }
                }
            }
        }

        const loadData = () => {
            if (props.date) {
                return api.getDealsByDate(dealsPerPage.value, pageNumber.value, finalExcludeDeal.value, props.date).then(postLoadData)
            }
            else {
                return api.getLatestDeals(dealsPerPage.value, pageNumber.value, finalExcludeDeal.value).then(postLoadData)
            }
        }

        const loadMoreData = () => {
            autoLoadMoreEnabled.value = false

            ga.event('click', { 'event_category': 'dealpage', 'event_label': pageNumber.value })
            clicky.log('Load More Deals - Page #' + pageNumber.value, 'click')

            if (document.getElementById('471381230'))
                document.getElementById('471381230').id = 'AD_DONE'

            isLoadingMore.value = true
            loadData().then(() => {
                isLoadingMore.value = false
                loadOneSignal()
            })
        }

        const autoLoadMore = () => {
            if (autoLoadMoreEnabled.value) {
                var loadMoreElem = document.querySelector('.load-more-container')
                if (loadMoreElem instanceof HTMLElement && util.checkVisible(loadMoreElem)) {
                    loadMoreData()
                }
            }
        }

        const loadOneSignal = () => {
            // OneSignal implementation removed as it was commented out
        }

        const init = () => {
            
            if (window.location.search.includes('direct'))
                isClean.value = true
            else
                isClean.value = false

            if (window.location.pathname.includes('giftideas') || window.location.pathname.includes('giftlist') || window.location.pathname.includes('gift-ideas'))
                isGiftList.value = true

            if (props.listOfDeals) {
                dealsPerPage.value = 300
                pageNumber.value = 1
                deals.value = props.listOfDeals
                isLoading.value = false
            }
            else {
                if (props.date) {
                    dealsPerPage.value = 49
                }

                isLoading.value = true
                isLoadingMore.value = false
                deals.value = []
                loadData().then(() => {
                    isLoading.value = false
                    showMoreDealsButton.value = true
                })
            }
        }

        onMounted(() => {
            init()
            window.addEventListener('scroll', autoLoadMore)
        })

        onBeforeUnmount(() => {
            window.removeEventListener('scroll', autoLoadMore)
        })

        return {
            isLoading,
            isLoadingMore,
            deals,
            dealsPerPage,
            pageNumber,
            showMoreDealsButton,
            autoLoadMoreEnabled,
            oneSignalInitiated,
            isGiftList,
            isClean,
            filterText, 
            filterCounter,
            finalExcludeDeal,
            onFilterChange,
            loadMoreData,
            directLinks: props.directLinks,
            settings,
            selectedDeal,
            showDealPrice
        }
    }
})
</script>

<style scoped>
.deal-modal-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 1000;
    background-color: rgba(255, 255, 255, 0.9);
}
</style>
